import $ from "jquery";

export interface GlobalToastProps {
  type?: "warning" | "info" | "error" | "success";
  title: string;
  description: string;
  timeOut?: number;
}

export function globalToast({
  type = "success",
  title,
  description,
  timeOut = 3000,
}: GlobalToastProps): void {
  let toastTimeStampClass = Math.round(new Date().getTime() / 1000);
  $(".js-toast-container").append(`
      <div
          class="toast js-toast-${toastTimeStampClass}"
          role="alert" aria-live="polite" aria-atomic="true" data-delay="${timeOut}"
          style="width: 300px;"
      >
          <div role="alert" aria-live="assertive" aria-atomic="true">
                   <div class="toast-header px-3 py-2 justify-content-between d-flex align-items-center">
                      <div class="d-flex align-items-center">
                          <div style="height: 8px; width: 8px;"
                          class="rounded-circle
                          ${
                            type == "info"
                              ? "bg-info"
                              : type == "error"
                              ? "bg-danger"
                              : type == "warning"
                              ? "bg-warning"
                              : type == "success"
                              ? "bg-success"
                              : ""
                          }
                          "></div>
                          <p class="ml-2 mb-0 text-sm font-weight-bold">${title}</p>
                      </div>

                      <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
              <div class="toast-body px-3 py-2">
                  ${description}
              </div>
          </div>
      </div>
      `);
  $(`.js-toast-${toastTimeStampClass}`).toast("show");
  $(`.js-toast-${toastTimeStampClass}`).on("hidden.bs.toast", function() {
    $(this).remove();
  });
}
